<template>
  <div class="d-flex m-3 gap-2">

    <!-- Main Content -->
    <div class="w-75 d-flex flex-column gap-3">
      <div class="card border-0 p-3 shadow-sm w-100">
        <h3 class="mb-2">Input</h3>
        <p class="text-gray-600 mb-2">Use Input to display input fields</p>
        
        <h5 class="mt-4 mb-2">How to Import</h5>
        <p class="text-gray-600">To import the Input component, install its package from bit.dev</p>
        <code class="bg-gray-100 p-3 mt-2">yarn add @bit/dtt.uic.dt-input</code>
      </div>

      <InputOverview />
      <InputSizingSample />
      <InputTypeSample />

      <div class="card border-0 p-3 shadow-sm w-100">
        <h4 class="mb-4 mt-2">Props</h4>
        <b-table striped bordered :items="items" :fields="fields"></b-table>
      </div>
    </div>
  </div>
</template>

<script>
import InputOverview from '@/components/local/Input/InputOverview'
import InputTypeSample from '@/components/local/Input/InputTypeSample'
import InputSizingSample from '@/components/local/Input/InputSizingSample'

export default {
  components: { 
      InputOverview,
      InputTypeSample,
      InputSizingSample
   },
  data () {
    return {
      components: [
        { name: 'Buttons', link: 'buttons' },
        { name: 'Input', link: 'input' },
      ],

      fields: [
        { key: 'prop', tdClass: 'setAmountTdClass' },
        { key: 'type', tdClass: 'setAmountTdClass' },
        { key: 'default', tdClass: 'setAmountTdClass' },
        { key: 'description' }
      ],

      items: [
        { prop: 'id', type: 'String', default: 'null', description: 'Used to set the id attribute on the rendered content' },
        { prop: 'debounce', type: 'String or Number', default: 0, description: 'When set to a number of milliseconds greater than zero, will debounce the user input.'},
        { prop: 'name', type: 'String', default: 'null', description: 'Sets the value of the name attribute on the form control' },
        { prop: 'trim', type: 'Boolean', default: 'false', description: 'When set, trims any leading and trailing white space from the input value.' },
        { prop: 'type', type: 'String', default: 'text', description: 'The type of input to render. See Bootstrap Vue Form Input for details.' },
        { prop: 'value', type: 'String', default: 'null', description: 'The current value of the input' },
        { prop: 'label', type: 'String', default: 'null', description: 'The label of the input' },
        { prop: 'placeholder', type: 'String', default: 'null', description: 'Sets the placeholder attribute value on the form control' },
        { prop: 'description', type: 'String', default: 'null', description: 'The description of the input' },
        { prop: 'size', type: 'String', default: 'md', description: "Set the size of the component's appearance. 'sm', 'md' (default), or 'lg'" },
        { prop: 'inline', type: 'Boolean', default: 'false', description: "Allows inline editing on the input field" },
        { prop: 'readonly', type: 'Boolean', default: 'false', description: "Sets the `readonly` attribute on the form control"},
        { prop: 'required', type: 'Boolean', default: 'false', description: 'Adds the required attribute to the form control' },
        { prop: 'disabled', type: 'Boolean', default: 'false', description: "When set to true, disables the component's functionality and places it in a disabled state" },
        { prop: 'errors', type: 'String', default: "''", description: 'Contains the error message in case a validation fails on an input' },
      ],
    }
  },

  methods: {
    setAmountTdClass() {
        return 'code-text'
    }
  }
}
</script>

<style>
.code-text {
  font-family: "SFMono-Regular", Menlo, Monaco, Consolas, "Liberation Mono" ,"Courier New", monospace;
  color: red!important;
}
</style>